import React from 'react';
import { FileUpload } from './FileUpload';
import { KeywordManager } from './KeywordManager';
import { ResultsView } from './ResultsView';
import { ExportView } from './ExportView';
import { useStore } from '../../stores/useStore';
import './PapersRefiner.css';

const PapersRefiner: React.FC = () => {
  const { activeTab, setActiveTab, papers, inclusionKeywords, exclusionKeywords, results } = useStore();

  const steps = [
    { id: 'upload', label: 'Upload', complete: papers.length > 0 },
    { id: 'keywords', label: 'Keywords', complete: inclusionKeywords.length > 0 || exclusionKeywords.length > 0 },
    { id: 'results', label: 'Results', complete: results !== null },
    { id: 'export', label: 'Export', complete: false },
  ];

  return (
    <div className="papers-refiner">
      <div className="papers-refiner-nav">
        {steps.map((step) => (
          <button
            key={step.id}
            onClick={() => setActiveTab(step.id as any)}
            className={'papers-refiner-tab ' + (activeTab === step.id ? 'active ' : '') + (step.complete ? 'complete' : '')}
          >
            <span className="tab-label">{step.label}</span>
            {step.complete && <span className="tab-check">✓</span>}
          </button>
        ))}
      </div>

      <div className="papers-refiner-progress">
        <div className="progress-track">
          {steps.map((step) => (
            <div
              key={step.id}
              className={'progress-segment ' + (step.complete ? 'complete' : '')}
              style={{ width: (100 / steps.length) + '%' }}
            />
          ))}
        </div>
        <div className="progress-info">
          {steps.filter(s => s.complete).length} / {steps.length} Schritte abgeschlossen
        </div>
      </div>

      <div className="papers-refiner-content">
        {activeTab === 'upload' && <FileUpload />}
        {activeTab === 'keywords' && <KeywordManager />}
        {activeTab === 'results' && <ResultsView />}
        {activeTab === 'export' && <ExportView />}
      </div>

      <div className="papers-refiner-stats">
        <div className="stat">
          <span className="stat-value">{papers.length.toLocaleString()}</span>
          <span className="stat-label">Papers</span>
        </div>
        <div className="stat">
          <span className="stat-value">{inclusionKeywords.length + exclusionKeywords.length}</span>
          <span className="stat-label">Keywords</span>
        </div>
        {results && (
          <div className="stat">
            <span className="stat-value">{results.inclusionOnly.length.toLocaleString()}</span>
            <span className="stat-label">Gefunden</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PapersRefiner;
